import i18next from 'i18next'
import i18nextXHRBackend from 'i18next-xhr-backend'
import { error, goToLobby } from '../redux/actions'
import config from "config"

export default function LoadTranslation(store, language, onLocaleLoaded) {
  let loadPath
  let lng = language
  
  const gameId = config.GAME_CONFIG.translationContext || config.GAME_CONFIG.BASEGAME_ID || config.GAME_CONFIG.GAME_ID || ''

  if (!gameId) {
    onLocaleLoaded('blank')
    return
  }
  
  const fallbackPath = `${config.staticTranslationUrl}${gameId}/{{lng}}.json`
  const fallBacks = []
  const lngLow = lng.toLowerCase()

  if (config.translationApiUrl) {
    loadPath = `${config.translationApiUrl}?style=dotted&context=${gameId}&locale={{lng}}`
    fallBacks.push({ lng: lngLow, loadPath: fallbackPath })
    if (lngLow !== 'en_gb') {
      fallBacks.push({ lng: 'en_GB', loadPath })
    }
  } else {
    lng = lngLow
    loadPath = fallbackPath
  }

  if (lngLow !== 'en_gb') {
    fallBacks.push({ lng: 'en_gb', loadPath: fallbackPath })
  }

  let i18

  const localeFail = () => {
    store.dispatch(error({
      errorCode: 102,
      errorMessage: "Translations unavailable",
      onClose: () => {
        const { session } = store.getState()
        if (!session.developerMode) {
          store.dispatch(goToLobby())
        } else {
          onLocaleLoaded('blank')
        }
      }
    }))
  }

  const onCallBack = (error) => {
    if (!error) {
      onLocaleLoaded(lng)
    } else {
      const fallback = fallBacks.shift()
      if (!fallback) {
        localeFail()
      } else {
        const { options } = i18
        options.backend.loadPath = fallback.loadPath
        options.lng = lng = fallback.lng
        i18.init(options, onCallBack)
      }
    }
  }

  i18 = i18next
    .use(i18nextXHRBackend)
    .init({
      lng,
      fallbackLng: false,
      keySeparator: '|',
      backend: {
        crossDomain: true,
        loadPath
      },
      interpolation: { escapeValue: false }
    }, onCallBack)
}
